import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromAction from './digital-course.action';
import { map, mergeMap, switchMap } from 'rxjs/operators';
import { Advantage, DigitalCourse, Question } from '@modules/course/digitalcourse/models';
import { DigitalCourseApiService } from '@modules/course/digitalcourse/store/services';
import { digitalCourseFeatureKey } from './digital-course.state';
import { AlertMessageType } from '@modules/shared/enums/alert-message-type';
import { EffectHelperService } from '@modules/core/services/effect-helper.service';

@Injectable()
export class DigitalCourseEffects {

  fetchDigitalCoursesEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.FetchDigitalCourses),
    mergeMap(({ queryParams, filter }) => {
      return this.digitalCourseApiService.getAllDigitalCourse(queryParams, filter).pipe(
        map(({items: courses}) => {
          return this.effectHelperService.handleSuccess(fromAction.AddDigitalCourses({ courses }))
        }),
        this.effectHelperService.handleError(fromAction.AddError, true, digitalCourseFeatureKey)
      );
    })
  ));


  fetchDigitalCourseEffect$  = createEffect(() => this.actions$.pipe(
    ofType(fromAction.FetchDigitalCourse),
    switchMap(({ courseId }) => {
      return this.digitalCourseApiService
        .getDigitalCourse(courseId)
        .pipe(
          map((course: DigitalCourse) => this.effectHelperService.handleSuccess(fromAction.AddDigitalCourse({ course }))),
          this.effectHelperService.handleError(fromAction.AddError, true, digitalCourseFeatureKey)
        );
    })
  ));


  fetchAdvantageEffect$  = createEffect(() => this.actions$.pipe(
    ofType(fromAction.FetchCourseAdvantage),
    switchMap(({ courseId }) => {
      return this.digitalCourseApiService
        .getCourseAdvantage(courseId)
        .pipe(
          map((advantages: Advantage[]) => this.effectHelperService.handleSuccess(fromAction.AddCourseAdvantage({ advantages }))),
          this.effectHelperService.handleError(fromAction.AddError, true, digitalCourseFeatureKey)
        );
    })
  ));


  fetchFaqEffect$ = createEffect(() => this.actions$.pipe(
    ofType(fromAction.FetchCourseQuestion),
    switchMap(({ courseId }) => {
      return this.digitalCourseApiService
        .getCourseFaq(courseId)
        .pipe(
          map((questions: Question[]) => this.effectHelperService.handleSuccess(fromAction.AddCourseQuestion({ questions }))),
          this.effectHelperService.handleError(fromAction.AddError, true, digitalCourseFeatureKey)
        );
    })
  ));


  saveCourseReview$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.SaveCourseReview),
    switchMap((payload) =>
      this.digitalCourseApiService.sendCourseReview(payload.courseId, payload.review).pipe(
        map((review) => this.effectHelperService.handleSuccess(fromAction.AddCourseReview({ review }), true, 'thanks_for_your_feedback', digitalCourseFeatureKey, AlertMessageType.SUCCESSFUL)),
        this.effectHelperService.handleError(fromAction.AddError, true, digitalCourseFeatureKey)
      )
    )
  ));

  constructor(
    private actions$: Actions,
    private digitalCourseApiService: DigitalCourseApiService,
    private effectHelperService: EffectHelperService
  ) {}
}
